import { render, staticRenderFns } from "./SpaceSearch.vue?vue&type=template&id=5c201e8a&scoped=true&"
import script from "./SpaceSearch.vue?vue&type=script&lang=js&"
export * from "./SpaceSearch.vue?vue&type=script&lang=js&"
import style0 from "./SpaceSearch.vue?vue&type=style&index=0&id=5c201e8a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c201e8a",
  null
  
)

export default component.exports